import { Component, Input, EventEmitter, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'emt-slide-toggle',
    templateUrl: './slide-toggle.component.html',
    styleUrls: ['./slide-toggle.component.scss'],
    imports: [NgClass, FormsModule],
})
export class SlideToggleComponent {
  @Input() labels: string[];
  @Output() toggle = new EventEmitter();
  @Input() isChecked: boolean;

  constructor() {}

  //toggle the stations inside the component
  toggleSwitch() {
    this.toggle.emit(this.isChecked);
  }
}
